import { LayoutRowConfig } from "@/app/(custom-header)/winners-template/LayoutTokens";

export type TemplateType =
  | "DreamCarWinner"
  | "HouseWinner"
  | "SinglePrizeCompWinner"
  | "MultiplePrizeCompWinner"
  | "InstantWinWinner";

export const dreamCarLayoutConfig: LayoutRowConfig[] = [
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    slots: {
      main: [
        "results-date", // show on mobile only
      ],
      side: ["section-title-1", "quote-1", "video"], // show on mobile only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    spacing: "xl",
    slots: {
      main: [
        "prize-won", // show on mobile only
      ],
      side: [
        "the-story", // show on mobile only
      ],
    },
  },
  {
    layoutType: "66/33",
    background: "gray",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["section-title-1", "quote-1", "video"], // show on desktop only
      side: ["competition-card"], // show on desktop only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    slots: {
      main: ["results-date", "prize-won", "the-story"], // show on desktop only
      side: ["aside-title-1", "aside-competition-1", "aside-competition-2"], // show on desktop only
    },
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-end",
    colsClassName: "flex flex-col gap-6",
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["aside-title-4"],
      side: ["explore-competitions-picks"],
    },
  },
  {
    layoutType: "empty",
    background: "ellipses",
    className: "bg-gray-100 px-2.5 lg:px-6 py-4 lg:py-8 w-full font-jost",
    slots: {
      main: ["extra-prizes-wrapper"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 mt-4 lg:mt-8",
    slots: {
      main: ["feeling-lucky-title"],
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 mb-4 lg:mb-8",
    slots: {
      main: ["featured-feeling-lucky"],
      side: ["feeling-lucky-daily-spin"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "lg:px-6 mt-4 lg:mt-8",
    sectionClassName: "bg-gray-100 px-2.5 lg:px-4 pt-6",
    colsClassName: "lg:flex lg:flex-col",
    slots: {
      main: ["winners-are-title"],
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "lg:px-6 mb-4 lg:mb-8",
    sectionClassName: "bg-gray-100 px-2.5 lg:px-4 pb-6",
    colsClassName: "lg:flex lg:flex-col",
    slots: {
      main: ["winners-are-game-photo"],
      side: ["winners-are-near-misses", "winners-are-reward-scheme"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["chance"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6",
    slots: {
      main: ["judging-title"],
    },
  },
  {
    layoutType: "50/50",
    width: "contained",
    className: "lg:px-6",
    innerClassName: "lg:items-stretch max-lg:gap-0 lg:gap-8",
    slots: {
      col1: ["judging-main"],
      col2: ["judging-side-information"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["skill-to-luck"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["explore-competitions"],
    },
  },
];

export const houseLayoutConfig: LayoutRowConfig[] = [
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    slots: {
      main: [
        "results-date", // show on mobile only
      ],
      side: ["section-title-1", "quote-1", "video"], // show on mobile only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    spacing: "xl",
    slots: {
      main: [
        "prize-won", // show on mobile only
      ],
      side: [
        "the-story", // show on mobile only
      ],
    },
  },
  {
    layoutType: "66/33",
    background: "gray",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["section-title-1", "quote-1", "video"], // show on desktop only
      side: ["competition-card"], // show on desktop only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    slots: {
      main: ["results-date", "prize-won", "the-story"], // show on desktop only
      side: ["aside-title-1", "aside-competition-1", "aside-competition-2"], // show on desktop only
    },
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-end",
    colsClassName: "flex flex-col gap-6",
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["aside-title-4"],
      side: ["explore-competitions-picks"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 mt-4 lg:mt-8",
    slots: {
      main: ["feeling-lucky-title"],
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 mb-4 lg:mb-8",
    slots: {
      main: ["featured-feeling-lucky"],
      side: ["feeling-lucky-daily-spin"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8 bg-[#F5F5F5]",
    slots: {
      main: ["house-slider"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["chance"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6",
    slots: {
      main: ["winner-is"],
    },
  },
  {
    layoutType: "50/50",
    width: "contained",
    className: "lg:px-6",
    innerClassName: "lg:items-stretch max-lg:gap-0 lg:gap-8",
    slots: {
      col1: ["judging-main"],
      col2: ["judging-side-information"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["skill-to-luck"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["explore-competitions"],
    },
  },
];

export const singlePrizeLayoutConfig: LayoutRowConfig[] = [
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    slots: {
      main: [
        "results-date", // show on mobile only
      ],
      side: ["section-title-1", "quote-1", "video"], // show on mobile only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    spacing: "xl",
    slots: {
      main: [
        "prize-won", // show on mobile only
      ],
      side: [
        "the-story", // show on mobile only
      ],
    },
  },
  {
    layoutType: "66/33",
    background: "gray",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["section-title-1", "quote-1", "video"], // show on desktop only
      side: ["competition-card"], // show on desktop only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    slots: {
      main: ["results-date", "prize-won", "the-story"], // show on desktop only
      side: ["aside-title-1", "aside-competition-1", "aside-competition-2"], // show on desktop only
    },
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-start",
    colsClassName: "flex flex-col gap-6",
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["aside-title-4"],
      side: ["explore-competitions-picks"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 mt-4 lg:mt-8",
    slots: {
      main: ["feeling-lucky-title"],
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 mb-4 lg:mb-8",
    slots: {
      main: ["featured-feeling-lucky"],
      side: ["feeling-lucky-daily-spin"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 mt-8",
    slots: {
      main: ["winner-is"],
    },
  },
  {
    layoutType: "50/50",
    width: "contained",
    className: "lg:px-6",
    innerClassName: "lg:items-stretch max-lg:gap-0 lg:gap-8",
    slots: {
      col1: ["judging-main"],
      col2: ["judging-side-information"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["chance"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["skill-to-luck"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["explore-competitions"],
    },
  },
];

export const multiplePrizesLayoutConfig: LayoutRowConfig[] = [
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    slots: {
      main: [
        "results-date", // show on mobile only
      ],
      side: ["video"], // show on mobile only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    colsClassName: "flex flex-col gap-6",
    spacing: "xl",
    slots: {
      main: ["multiple-winners"], // show on mobile only
    },
  },
  {
    layoutType: "66/33",
    background: "gray",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["video"], // show on desktop only
      side: ["competition-card"], // show on desktop only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    slots: {
      main: ["results-date", "prize-won", "multiple-winners"], // show on desktop only
      side: ["aside-title-1", "aside-competition-1", "aside-competition-2"], // show on desktop only
    },
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-start",
    colsClassName: "flex flex-col gap-6",
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["aside-title-4"],
      side: ["explore-competitions-picks"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 mt-2 lg:mt-0",
    slots: {
      main: ["feeling-lucky-title"],
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 mb-4 lg:mb-8",
    slots: {
      main: ["featured-feeling-lucky"],
      side: ["feeling-lucky-daily-spin"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6",
    slots: {
      main: ["winner-is"],
    },
  },
  {
    layoutType: "50/50",
    width: "contained",
    className: "lg:px-6",
    innerClassName: "lg:items-stretch max-lg:gap-0 lg:gap-8",
    slots: {
      col1: ["judging-main"],
      col2: ["judging-side-information"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["chance"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["skill-to-luck"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["explore-competitions"],
    },
  },
];

export const instantWinLayoutConfig: LayoutRowConfig[] = [
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    slots: {
      main: [
        "results-date", // show on mobile only
      ],
      side: ["video"], // show on mobile only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 pt-4 pb-2 lg:py-8 lg:hidden",
    colsClassName: "flex flex-col gap-6",
    spacing: "xl",
    slots: {
      main: [
        "prize-won", // show on mobile only
      ],
      side: ["top-winners", "all-winners-prizes"], // show on mobile only
    },
  },
  {
    layoutType: "66/33",
    background: "gray",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["video"], // show on desktop only
      side: ["competition-card"], // show on desktop only
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    slots: {
      main: ["results-date", "prize-won", "top-winners", "all-winners-prizes"], // show on desktop only
      side: ["aside-title-1", "aside-competition-1", "aside-competition-2"], // show on desktop only
    },
    className: "px-2.5 lg:px-6 py-4 lg:py-8 max-lg:hidden",
    innerClassName: "items-start",
    colsClassName: "flex flex-col gap-6",
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 py-4 lg:py-8 lg:hidden",
    innerClassName: "items-end",
    slots: {
      main: ["aside-title-4"],
      side: ["explore-competitions-picks"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 mt-2 lg:mt-0",
    slots: {
      main: ["feeling-lucky-title"],
    },
  },
  {
    layoutType: "66/33",
    width: "contained",
    className: "px-2.5 lg:px-6 mb-4 lg:mb-8",
    slots: {
      main: ["featured-feeling-lucky"],
      side: ["feeling-lucky-daily-spin"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6",
    slots: {
      main: ["winner-is"],
    },
  },
  {
    layoutType: "50/50",
    width: "contained",
    className: "lg:px-6",
    innerClassName: "lg:items-stretch max-lg:gap-0 lg:gap-8",
    slots: {
      col1: ["judging-main"],
      col2: ["judging-side-information"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["chance"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["skill-to-luck"],
    },
  },
  {
    layoutType: "full",
    width: "contained",
    className: "px-2.5 lg:px-6 my-4 lg:my-8",
    slots: {
      main: ["explore-competitions"],
    },
  },
];

const templateConfigMap: Record<TemplateType, LayoutRowConfig[]> = {
  DreamCarWinner: dreamCarLayoutConfig,
  HouseWinner: houseLayoutConfig,
  SinglePrizeCompWinner: singlePrizeLayoutConfig,
  MultiplePrizeCompWinner: multiplePrizesLayoutConfig,
  InstantWinWinner: instantWinLayoutConfig,
};

export const getTemplateConfig = (template: TemplateType | undefined): LayoutRowConfig[] => {
  return templateConfigMap[template];
};
